import React from 'react';
import { MapPin, Phone, Mail, Clock, ExternalLink } from 'lucide-react';
import { practiceInfo, openingHours } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Practice Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">
              Frauenarztpraxis<br />
              <span className="text-red-300">Dr. med. Christina Weiß</span>
            </h3>
            <p className="text-gray-300 mb-4 leading-relaxed">
              Ihre vertrauensvolle Praxis für Gynäkologie und Geburtshilfe 
              in Gronau (Leine). Seit {practiceInfo.since} für Sie da.
            </p>
            <div className="flex items-center text-gray-300 mb-2">
              <MapPin className="h-4 w-4 mr-2 text-red-400" />
              <span className="text-sm">
                {practiceInfo.address.street}, {practiceInfo.address.city}
              </span>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-red-300">Kontakt</h4>
            <div className="space-y-3">
              <div className="flex items-center text-gray-300">
                <Phone className="h-4 w-4 mr-3 text-red-400" />
                <span className="text-sm">{practiceInfo.contact.phone}</span>
              </div>
              <div className="flex items-center text-gray-300">
                <Mail className="h-4 w-4 mr-3 text-red-400" />
                <a 
                  href="mailto:terminanfrage@frauenarzt-praxis-gronau.de"
                  className="text-sm text-gray-300 hover:text-red-300 underline"
                >
                  {practiceInfo.contact.email}
                </a>
              </div>
              <div className="flex items-start text-gray-300">
                <ExternalLink className="h-4 w-4 mr-3 text-red-400 mt-1" />
                <div>
                  <p className="text-sm font-medium">Online Terminbuchung</p>
                  <button
                    onClick={() => window.open(practiceInfo.contact.booking_url, '_blank')}
                    className="text-red-400 hover:text-red-300 text-sm underline transition-colors duration-200"
                  >
                    Jetzt buchen
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-red-300">Sprechzeiten</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex justify-between">
                <span>Mo, Di:</span>
                <span>8:30-12:00, 13:00-16:00</span>
              </div>
              <div className="flex justify-between">
                <span>Mi:</span>
                <span>14:00-18:00</span>
              </div>
              <div className="flex justify-between">
                <span>Do:</span>
                <span>8:30-12:00, 15:00-18:00</span>
              </div>
              <div className="flex justify-between">
                <span>Fr:</span>
                <span>8:30-13:00</span>
              </div>
              <div className="border-t border-gray-700 pt-2 mt-3">
                <p className="text-orange-300 font-medium">Offene Sprechstunden:</p>
                <p className="text-xs">{openingHours.emergency}</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-red-300">Navigation</h4>
            <div className="space-y-2">
              <button
                onClick={() => document.getElementById('praxis').scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-300 hover:text-red-300 text-sm transition-colors duration-200"
              >
                Über uns
              </button>
              <button
                onClick={() => document.getElementById('leistungen').scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-300 hover:text-red-300 text-sm transition-colors duration-200"
              >
                Leistungen
              </button>
              <button
                onClick={() => document.getElementById('team').scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-300 hover:text-red-300 text-sm transition-colors duration-200"
              >
                Unser Team
              </button>
              <button
                onClick={() => document.getElementById('sprechzeiten').scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-300 hover:text-red-300 text-sm transition-colors duration-200"
              >
                Sprechzeiten
              </button>
              <button
                onClick={() => document.getElementById('kontakt').scrollIntoView({ behavior: 'smooth' })}
                className="block text-gray-300 hover:text-red-300 text-sm transition-colors duration-200"
              >
                Kontakt
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Frauenarztpraxis Dr. med. Christina Weiß. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-red-300 transition-colors duration-200">
                Impressum
              </a>
              <a href="#" className="text-gray-400 hover:text-red-300 transition-colors duration-200">
                Datenschutz
              </a>
              <a href="#" className="text-gray-400 hover:text-red-300 transition-colors duration-200">
                Sprechzeiten
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;